import React, { useState, useRef } from 'react'
import { Row, Col, Tabs, Tab, Form } from 'react-bootstrap'
import moment from 'moment'
import { MoreVert } from '@mui/icons-material'
import { MTableAction } from '@material-table/core'

import { Item, Menu, useContextMenu } from 'react-contexify'
import 'react-contexify/dist/ReactContexify.min.css'

import Table from 'components/Table/DataTable'

import { currencyConvert } from 'utility/convert.util'

const TabsDetail = ({ invoice, setInvoice, onRestore }) => {
  const [key, setKey] = useState('สรุปรายการ')
  const [dataRowSelected, setDataRowSelected] = useState({})

  const tableRef = useRef()
  const MENU_ID = 'charge-category-menu'

  const { show } = useContextMenu({
    id: MENU_ID,
  })

  const handleContextMenu = async (event) => {
    await event.preventDefault()
    await show(event, {
      id: 'charge-category-menu',
    })
  }

  const handleEditRow = (dataSelected) => {
    console.log('dataSelected ', dataSelected)
    const materialTable = tableRef.current
    if (materialTable) {
      materialTable.dataManager.changeRowEditing(dataSelected, 'update')
    }
    console.log('tableRef ', tableRef.current)
  }
  const MenuLeftClick = ({ dataSelected }) => {
    return (
      <Menu id="charge-category-menu">
        <Item onClick={() => handleEditRow(dataSelected)}>ลงยอดค้างชำระ</Item>
        <Item onClick={onRestore}>คืนค่าเดิม</Item>
      </Menu>
    )
  }

  const columns = [
    { title: 'ลำดับ', field: 'seq', editable: 'never' },
    {
      title: 'รหัส',
      field: 'chargeCategory',
      editable: 'never',
      render: ({ chargeCategory }) => chargeCategory?.chargeCategoryCode,
    },
    {
      title: 'ชื่อรายได้',
      field: 'chargeCategory',
      editable: 'never',
      render: ({ chargeCategory }) => chargeCategory?.name,
    },
    {
      title: 'ชำระเอง',
      field: 'selfPayWithInsuranceAmount',
      type: 'numeric',
      editable: 'never',
      render: ({ selfPayWithInsuranceAmount }) =>
        currencyConvert(selfPayWithInsuranceAmount),
    },
    {
      title: 'เบิกไม่ได้',
      field: 'selfPayWithoutInsuranceAmount',
      type: 'numeric',
      editable: 'never',
      render: ({ selfPayWithoutInsuranceAmount }) =>
        currencyConvert(selfPayWithoutInsuranceAmount),
    },
    {
      title: 'ลูกหนี้สิทธิ',
      field: 'insuranceAmount',
      type: 'numeric',
      editable: 'never',
      render: ({ insuranceAmount }) => currencyConvert(insuranceAmount),
    },
    {
      title: 'ค้างชำระ',
      field: 'arrearAmount',
      type: 'numeric',
      render: ({ arrearAmount }) => currencyConvert(arrearAmount),
    },
    {
      title: 'ส่วนลด',
      field: 'discountAmount',
      type: 'numeric',
      editable: 'never',
      render: ({ discountAmount }) => currencyConvert(discountAmount),
    },
    {
      title: '%',
      field: 'discountPercentage',
      editable: 'never',
      type: 'numeric',
    },
    {
      title: 'รวมเงิน',
      field: 'totalAmount',
      type: 'numeric',
      editable: 'never',
      render: ({ totalAmount }) => currencyConvert(totalAmount),
    },
  ]

  const chargeItemColumn = [
    { title: 'ลำดับ', field: 'seq' },

    {
      title: 'ชื่อรายการ',
      field: 'name',
      render: ({ name }) => name,
    },
    {
      title: 'จำนวน',
      field: 'qty',
      type: 'numeric',
    },
    {
      title: 'ราคา',
      field: 'unitPrice',
      type: 'numeric',
      render: ({ unitPrice }) => currencyConvert(unitPrice),
    },
    {
      title: 'ราคารวม',
      field: 'sumPrice',
      type: 'numeric',
      render: ({ sumPrice }) => currencyConvert(sumPrice),
    },
    {
      title: 'หมวด',
      field: 'chargeCategory',
      render: ({ chargeCategory }) => chargeCategory?.name,
    },

    {
      title: 'รูปแบบการชำระ',
      field: ' paidByType',
      type: 'numeric',
      render: ({ paidByType }) => paidByType?.name,
    },
  ]

  const bedItemColumn = [
    {
      title: 'ลำดับ',
      field: 'seq',
      align: 'center',
    },
    {
      title: 'ชื่อรายการ',
      field: 'name',
      align: 'center',
    },
    {
      title: 'ช่วงเวลา',
      field: 'date',
      align: 'center',
      render: ({ startDate, endDate }) =>
        `${moment(startDate).format('DD-MM-YYYY')} - ${moment(endDate).format(
          'DD-MM-YYYY',
        )}`,
    },
    {
      title: 'จำนวนวัน',
      field: 'dayQty',
      align: 'right',
    },
    {
      title: 'วันลา',
      field: 'dayLeaveQty',
      align: 'right',
    },
    {
      title: 'วันนอนจริง',
      field: 'dayChargeQty',
      align: 'right',
    },
    {
      title: 'ราคา',
      field: 'unitPrice',
      align: 'right',
      render: ({ unitPrice }) => currencyConvert(unitPrice),
    },
    {
      title: 'ราคารวม',
      field: 'sumPrice',
      align: 'right',
      render: ({ sumPrice }) => currencyConvert(sumPrice),
    },
    {
      title: 'หมวด',
      field: 'chargeCategory',
      align: 'center',
      render: ({ chargeCategory }) => chargeCategory?.name,
    },
    {
      title: 'รูปแบบการชำระ',
      field: 'benefitType',
      align: 'center',
      render: ({ benefitType }) => benefitType?.name,
    },
  ]
  return (
    <>
      <Tabs
        id="finance-tab"
        activeKey={key}
        onSelect={(k) => setKey(k)}
        className="mb-3"
      >
        <Tab eventKey="สรุปรายการ" title="สรุปรายการ">
          <Row>
            <Col sm="12" className="my-2">
              <Table
                tableRef={tableRef}
                columns={columns}
                data={invoice?.chargeCategory}
                options={{
                  toolbar: false,
                  headerStyle: {
                    textOverflow: 'clip',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                  },
                  cellStyle: {
                    minWidth: 120,
                    maxWidth: 300,
                    textOverflow: 'clip',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                  },
                }}
                editable={{
                  onRowUpdate: (newData, oldData) =>
                    new Promise((resolve, reject) => {
                      setTimeout(() => {
                        const dataUpdate = [...invoice?.chargeCategory]
                        const index = invoice?.chargeCategory.findIndex(
                          (element) => element.seq === oldData.seq,
                        )

                        dataUpdate[index] = newData

                        setInvoice({
                          ...invoice,
                          chargeCategory: dataUpdate,
                        })
                        resolve()
                      }, 1000)
                    }),
                }}
                actions={[
                  {
                    icon: MoreVert,
                    tooltip: 'More Option',
                    onClick: async (event, rowData) => {
                      await setDataRowSelected(rowData)
                      await handleContextMenu(event)
                    },
                  },
                ]}
              />

              <MenuLeftClick dataSelected={dataRowSelected} />
            </Col>
          </Row>
        </Tab>
        <Tab eventKey="รายละเอียด" title="รายละเอียด">
          <Row>
            <Col sm="12" className="my-2">
              <Table
                columns={chargeItemColumn}
                data={invoice?.chargeItem}
                options={{
                  toolbar: false,
                  headerStyle: {
                    textOverflow: 'clip',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                  },
                  cellStyle: {
                    minWidth: 120,
                    maxWidth: 300,
                    textOverflow: 'clip',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                  },
                }}
              />
            </Col>
          </Row>
        </Tab>
        <Tab eventKey="รายการค่าเตียง" title="รายการค่าเตียง">
          <Row>
            <Col sm="12" className="my-2">
              <Table
                columns={bedItemColumn}
                data={invoice?.chargeBedItem}
                options={{
                  toolbar: false,
                  headerStyle: {
                    textOverflow: 'clip',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                  },
                  cellStyle: {
                    minWidth: 120,
                    maxWidth: 300,
                    textOverflow: 'clip',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                  },
                }}
              />

              <Row>
                <Col sm="12" className="d-flex justify-content-end my-2">
                  <Form>
                    <Form.Group as={Row} className="mb-2">
                      <Form.Label column sm={5} className="text-right">
                        รวมวันนอน
                      </Form.Label>
                      <Col sm={4}>
                        <Form.Control
                          type="text"
                          value={currencyConvert(
                            invoice?.bedInfo?.totalSleepDayCount,
                          )}
                          readOnly
                          className="text-right"
                        />
                      </Col>
                      <Col sm={3} className="my-auto">
                        วัน
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-2">
                      <Form.Label column sm={5} className="text-right">
                        รวมวันลา
                      </Form.Label>
                      <Col sm={4}>
                        <Form.Control
                          type="text"
                          value={currencyConvert(
                            invoice?.bedInfo?.totalDayChangeCount,
                          )}
                          readOnly
                          className="text-right"
                        />
                      </Col>
                      <Col sm={3} className="my-auto">
                        วัน
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-2">
                      <Form.Label column sm={5} className="text-right">
                        รวมวันนอนจริง
                      </Form.Label>
                      <Col sm={4}>
                        <Form.Control
                          type="text"
                          value={currencyConvert(
                            invoice?.bedInfo?.totalDayLeaveCount,
                          )}
                          readOnly
                          className="text-right"
                        />
                      </Col>
                      <Col sm={3} className="my-auto">
                        วัน
                      </Col>
                    </Form.Group>
                  </Form>
                </Col>
              </Row>
            </Col>
          </Row>
        </Tab>
      </Tabs>
    </>
  )
}

export default TabsDetail
